export default __webpack_public_path__ + "static/media/world-d-title__2.6854da20.png";